<script>
import CartView from './_cart.svelte'
import Checkout from './_checkout.svelte'
import Complete from './_complete.svelte'
import cart from '$src/store/cart.js'

let complete = false
</script>

{#if !process.browser}
  <p>Loading...</p>
{:else if complete}
  <Complete />
{:else if $cart.length === 0}
  <p>You have no items in your cart.  Try looking through the <a href="/shop">shop</a>!</p>
{:else}
  <CartView />
  <Checkout on:paymentComplete={ () => complete = true } />
{/if}
